<div class="location-selector">
  <div class="sticky-search-bar">
    <lx-searcher [queryReset]="visible" [autofocus]="visible" (searchTriggered)="filterLocation($event)" data-qa="locationSearch_input"></lx-searcher>
  </div>

  <div class="listbox-options listbox-options--margin">
    <lx-list-box
      [options]="groupedSchoolLocations$ | async"
      [group]="true"
      [(ngModel)]="selectedSchoolLocationCode"
      (ngModelChange)="triggerSelectedSchoolLocationChanged()"
      data-qa="schoolSelection__list"
    >
      >
      <ng-template #customGroupTemplate let-group>
        <div class="location-selector__options__grouped" data-qa="country_selection">
          <img
            ngSrc="/assets/images/flag_placeholder.png"
            [width]="flagImageWidth"
            [height]="flagImageHeight"
            [class]="'flag flag-' + group.value | lowercase"
            [alt]="group.label + ' flag'"
          />
          <span>{{ group.label }}</span>
        </div>
      </ng-template>
    </lx-list-box>
  </div>
</div>
